import ValueFactory from '../../util/ValueFactory';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { ListVariableActions } from '../actions/ListVariableActions';
import { ListVariable } from '../../domain/enrichment/EnrichmentDomain';
import DeploymentModel from '../../domain/stream/model/DeploymentModel';
import { ListVariableSchema } from '../../domain/enrichment/EnrichmentSchemaDomains';

export interface ListVariableState {
  listVariable: ListVariable;
  schema: DeploymentModel<ListVariableSchema> | null;
  isUpdate: boolean;
  isDirty: boolean;
}

const initialState: ListVariableState = {
  listVariable: ValueFactory.initializeListVariable(),
  schema: { stage: 'DRAFT' } as DeploymentModel<ListVariableSchema>,
  isUpdate: false,
  isDirty: false,
};

export const listVariableReducer = (state = initialState, action: ReduxBaseAction<any, ListVariableActions>) => {
  switch (action.type) {
    case 'CHANGE_LIST_VARIABLE':
      return { ...state, listVariable: action.payload, isDirty: true };
    case 'CHANGE_LIST_VARIABLE_SCHEMA':
      return { ...state, schema: action.payload };
    case 'CHANGE_LIST_VARIABLE_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_LIST_VARIABLE':
      return { ...state, listVariable: ValueFactory.initializeListVariable(), schema: null, isDirty: false };
    case 'CHANGE_LIST_VARIABLE_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
